export const ServiceType = 'saq';
